import { useState, useEffect } from 'react';
import { api } from '../lib/api.js';

// Manager queue of pending timeclock correction requests for one
// location. Sits at the top of TimecardReviewPanel — manager triages
// each one (approve to apply, deny with optional reason).
export function CorrectionRequestQueue({ location, currentUser, onApplied }) {
  const headers = { 'x-user-id': String(currentUser.id) };
  const [requests, setRequests] = useState([]);
  const [busy, setBusy] = useState(null);

  async function load() {
    try {
      const r = await api('GET', `/api/admin/timeclock/correction-requests?location_id=${location.id}&status=pending`, null, headers);
      setRequests(r.requests || []);
    } catch (e) { /* fail soft */ }
  }
  useEffect(() => { load(); }, [location.id]);

  async function approve(req) {
    setBusy(req.id);
    try {
      await api('POST', `/api/admin/timeclock/correction-requests/${req.id}/approve`, {}, headers);
      load(); onApplied && onApplied();
    } catch (e) {
      let m = e.message; try { m = JSON.parse(e.message).error; } catch {}
      alert(`Approve failed: ${m}`);
    } finally { setBusy(null); }
  }
  async function deny(req) {
    const note = prompt('Reason for denial (optional)?') || '';
    setBusy(req.id);
    try {
      await api('POST', `/api/admin/timeclock/correction-requests/${req.id}/deny`, { review_note: note }, headers);
      load();
    } catch (e) {
      let m = e.message; try { m = JSON.parse(e.message).error; } catch {}
      alert(`Deny failed: ${m}`);
    } finally { setBusy(null); }
  }

  if (requests.length === 0) return null;
  return (
    <div className="card" style={{ borderLeft: '4px solid #d97706', padding: 12, marginBottom: 12 }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: '#92400e', marginBottom: 6 }}>
        {requests.length} pending correction request{requests.length === 1 ? '' : 's'}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {requests.map(r => (
          <div key={r.id} style={{ background: '#fffbea', border: '1px solid #fde68a', borderRadius: 8, padding: 10 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', flexWrap: 'wrap', gap: 8 }}>
              <div>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#212121' }}>{r.user_name}</div>
                <div style={{ fontSize: 11, color: '#92400e' }}>
                  {r.request_type === 'add_punch' ? 'Forgot to clock in' : 'Times wrong'} · {r.shift_date}
                </div>
              </div>
              <div style={{ display: 'flex', gap: 6 }}>
                <button onClick={() => deny(r)} disabled={busy === r.id}
                  style={{ padding: '6px 12px', fontSize: 12, fontWeight: 600, fontFamily: 'inherit',
                            background: '#fff', color: '#dc2626', border: '1px solid #fecaca', borderRadius: 6, cursor: 'pointer' }}>
                  Deny
                </button>
                <button onClick={() => approve(r)} disabled={busy === r.id}
                  style={{ padding: '6px 12px', fontSize: 12, fontWeight: 700, fontFamily: 'inherit',
                            background: '#16a34a', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>
                  {busy === r.id ? '…' : 'Approve'}
                </button>
              </div>
            </div>
            <div style={{ fontSize: 12, color: '#37474f', marginTop: 6 }}>
              {r.proposed_clock_in_at && <span>In: {new Date(r.proposed_clock_in_at).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })}</span>}
              {r.proposed_clock_out_at && <span style={{ marginLeft: 12 }}>Out: {new Date(r.proposed_clock_out_at).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })}</span>}
            </div>
            {r.reason && (
              <div style={{ fontSize: 12, color: '#5b3b00', marginTop: 4, fontStyle: 'italic' }}>
                "{r.reason}"
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
